module.exports = {
    languages: ["it", "gb"],
     asian_test_apiBaseUrl: "https://testapi.pokerplaza.com/api",
     apiBaseUrl: "https://pgapi.draftplaza.com/api",
    // apiBaseUrl: "http://185.140.230.65:3000/api",
};
